<template>
    <div class="container-render-post">
        <AudioPlayer
            v-if="music"
            ref="music-audio"
            :src="(this.music.track || this.music.original_sound).progressive_download_url"
            :start="parseInt((this.music.start || 0)/1000)"
            :duration="parseInt((this.music.duration || 0)/1000)"
            :loop="true"
            :volume="!mutedSound && !modes.includes('addMusicMode') ? 0.5 : 0"
        />
  
        <div :class="'render-post hide-scrollbar render-post-instagram '+modes.join(' ')" :style="{ fontSize: fontSize + 'px' }" ref="render-post">
            <div class="header-app">
                Publication
            </div>
            <div class="post-content">
                <div class="post-header">
                    <div class="info">
                        <div class="img-pages">
                            <template v-for="(page, index) in pages.slice(0,pages.length == 4 ? 4 : 3)" >
                                <Tooltip 
                                    :active="page.iconEdited" 
                                    :key="index" 
                                    :text="'Voir les modifications apportées'" 
                                    position="right" 
                                    :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`" 
                                    @click="()=>{page.iconEdited ? $emit('clickPage', page.id) : openInstagramPage(page)}"
                                >
                                    <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                                </Tooltip>
                            </template>
                        
                            <div class="page count" v-if="pages.length > 4">
                                <p>+{{ pages.length - 3 }}</p>
                            </div>
                        </div>
                        <div class="info-text-header">
                            <div class="container-name">
                                <p>
                                    <span class="name" v-if="pages.length == 1" @click="openInstagramPage(pages[0])">{{ pages[0].name }} &nbsp;</span>
                                    <span class="collaborator" v-if="collaborators.length">et <span>{{ collaborators[0].name || collaborators[0].id}}</span>&nbsp;</span>
                                    <i class="fa-solid fa-circle"></i>
                                    <span class="date">&nbsp;{{ datePost ? formatDatePost : 'A l\'instant' }} </span>
                                </p>
                               
                            </div>
                            <p class="location" v-if="place && place.name">{{ place.name }}</p>
                        </div>
                       
                    </div>
                    <div class="more"><i class="fa-solid fa-ellipsis"></i></div>
                </div>
                <div class="post-medias">
                    <div 
                        class="carousel" 
                        :class="{singleMedia:medias && medias.length == 1}"
                        @mousedown="mouseDownOnPost" 
                        @mouseup="clickOnPost"
                        :style="{'aspect-ratio' : ratioCalculated ? ratioCalculated.replace(':','/') : '1/1'}"
                    >
                        <div 
                            v-for="person in personsIdentifiedSlideCarousel" 
                            :class="`floating-tag personIndentifed ${getClassForFloatingTag(person.x,person.y)} ${showTagPersonIndentifed ? 'show' : 'hide'}`" 
                            :style="{left: `${person.x}%`, top: `${person.y}%`}" 
                            :key="person.name || person.id"
                        >
                            {{person.name || person.id}}
                        </div>

                        <div 
                            v-for="product in productSlideCarousel" 
                            :class="`floating-tag product ${getClassForFloatingTag(product.x,product.y)} ${showTagPersonIndentifed ? 'show' : 'hide'}`" 
                            :style="{left: `${product.x}%`, top: `${product.y}%`}" 
                            :key="product.id"
                        >
                            {{product.text}}
                        </div>

                        <template v-if="medias.length">
                            <i v-if="slideIndexCarousel > 0" class="fa-sharp fa-solid fa-circle-chevron-left" @click="prevIndexCarousel"></i>
                            <i v-if="slideIndexCarousel+1 < medias.length" class="fa-sharp fa-solid fa-circle-chevron-right" @click="nextIndexCarousel"></i>
                        </template>
                      

                        <carousel ref="carousel" :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="slideChangeCarousel">
                            <Slide v-for="(media, index) in medias.slice(0,20)" :key="media.id">
                                <div class="item">
                                    <template v-if="media.info.type.startsWith('video/')">
                                        <video 
                                            preload="metadata" 
                                            class="video" 
                                            onloadedmetadata="this.muted = true"
                                            playsinline autoplay loop 
                                            :src="media.url"
                                            :type="media.info.type"
                                            :muted="slideIndexCarousel !== index || mutedSound || music || modes.includes('addMusicMode')"
                                        >
                                           
                                        </video>
                                    </template>
                                    <template v-else >
                                        <img
                                            :style="{
                                                //'object-fit' : media.info.width / media.info.height > 2.111111111111111 ? 'cover' : media.info.width / media.info.height > ratioCalculated.split(':').reduce((a, b) => a / b) ? 'contain' : 'cover',
                                                // 'aspect-ratio': media.info.width / media.info.height > 2.111111111111111 ? '16/9' : null
                                            }"
                                            :src="media.url" 
                                            alt=""
                                        >
                                    </template>

                                   
                                </div>
                            </Slide>
                        </carousel>

                        <div class="pictograms left">
                            <div v-if="productSlideCarousel.length" class="pictogram product"></div> 
                            <div v-if="personsIdentifiedSlideCarousel.length" class="pictogram user"></div> 
                        </div>
                        
                        <div class="pictograms right">
                            <div class="pictogram"  v-if="music || (slideIndexCarousel >= 0 && medias[slideIndexCarousel] && medias[slideIndexCarousel].info.type2 == 'video')" :class="mutedSound ? 'no-sound' : 'sound' "></div>
                        </div>
                        
                    </div>
                </div>
                <div class="post-footer">
                    <div class="like">
                        <svg height="100%" viewBox="0 0 24 24" width="100%"><path d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z"></path></svg>
                    </div>
                    <div class="comment">
                        <svg height="100%" viewBox="0 0 24 24" width="100%"><path d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z" fill="none" stroke="#000000" stroke-linejoin="round" stroke-width="2"></path></svg>
                    </div>
                </div>
                <div class="description" v-if="text">
                <!-- <div class="img-pages">
                    <div class="page">
                        <img :src="!pages || !pages.length || pages.length > 1 || !pages[0] ?  'img/avatar.jpg' : pages[0].avatar" alt="">
                    </div>

                </div> -->
                    <div class="content">
                    
                        <p class="text">
                            <span class="page-name">{{ pages.length > 1 ? 'Auteur' : pages[0].name}}</span>
                            <span v-html="textTranslateMentionAndHastag"></span>
                        </p>
                    </div>
                </div>
                <div class="first-comment" v-for="comment in commentsTranslateMentionAndHastag">
                    <div class="img-pages">
                        <div class="page">
                            <img :src="!pages || !pages.length || pages.length > 1 || !pages[0] ?  'img/avatar.jpg' : pages[0].avatar" alt="">
                        </div>
               
                    </div>
                    <div class="content">
                        <p class="page-name">{{ pages.length > 1 ? 'Auteur' : pages[0].name}}</p>
                        <p class="text" v-html="comment"></p>
                    </div>
                    <i class="fa-regular fa-heart"></i>
                </div>
            </div>
        </div>



        <SelectPerson v-if="modes.includes('addIdentifierMode')"
            :personsSelect="personsIdentified"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            :maxPersons="10"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
            
        />
        <SelectPerson v-if="modes.includes('addCollaboratorMode')"
            :personsSelect="collaborators"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            :maxPersons="5"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
        />
    
        <SelectPlace v-if="modes.includes('addPlaceMode')" 
            @close="closeContentOverflow"
            :placeSelected="place"
            :position="positionFormOverlay"
            :network="'instagram'"
        />
        <SelectMusic v-if="modes.includes('addMusicMode')" 
            @close="closeContentOverflow" 
            :musicSelected="music"
            :position="positionFormOverlay"
        />
        <SelectProduct v-if="modes.includes('addProductMode')"
            :productsSelect="products"
            :positionClick="paramsContentOverflow.identify.positionClick"
            :position="positionFormOverlay"
            @close="closeContentOverflow"
            @resetPositionClick="resetClick"
        />
    </div>
    
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { Carousel, Slide } from 'vue-carousel';
    import SelectMusic from '../../formOverlay/selectMusic.vue';
    import SelectPlace from '../../formOverlay/selectPlace.vue';
    import SelectPerson from '../../formOverlay/selectPerson.vue';
    import SelectProduct from '../../formOverlay/selectProduct.vue';
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';
    import AudioPlayer from '../../audioPlayer.vue';
    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SelectMusic,
            SelectPlace,
            SelectPerson,
            SelectProduct,
            Tooltip,
            AudioPlayer
        },

        props: {
            pages: {
                type: Array,
                default: () => [] 
            },

            datePost: {
                default: 1315349759920 
            },
            text : {
                type: String,
                default: ''
            },
            comments : {
                type: Array,
                default: ()=>[]
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },   
            personsIdentified: {
                type: Array,
                default: ()=>[] 
            },
            collaborators: {
                type: Array,
                default: ()=>[] 
            },
            place: {
                type: Object,
                default: undefined
            },
            music: {
                type: Object,
                default: undefined
            },
            ratio : {
                type: String,
                default: '4:5'
            },
            modes: {
                type: Array,
                default: ()=>[] 
            },
            mentions : {
                type: Object,
                default: ()=>({})
            },
            products: {
                type: Array,
                default: ()=>[] 
            },

            positionFormOverlay: {
                type: String,
                default: 'left'
            },

            
            

        },
        
        data() {
            return {
                paramsContentOverflow : {
                    identify : {
                        positionClick : undefined,
                        lastMouseDownEvent: {}
                    },
                    // place : {
                    //     steep : 1,
                    // },
                    // music : {
                    //     steep : 1,
                    // }
                },
                slideIndexCarousel : 0,
                showTagPersonIndentifed : true,
                
                mutedSound : true,
                lastMouseUpPost: null,
               
            }
        },

        mounted () {
        },

        methods: {

            mouseDownOnPost(e) {
                this.lastMouseUpPost = Date.now();
                this.showTagPersonIndentifed = false
                this.paramsContentOverflow.identify.lastMouseDownEvent = {
                    clientX : e.clientX,
                    clientY : e.clientY
                }
            },

            mouseUpOnPost() {
                this.showTagPersonIndentifed = true
            },
            clickOnPost(e) {
                if (Date.now() - this.lastMouseUpPost > 200) return
                if (e.target.type !== 'button' && Math.abs(e.clientX - this.paramsContentOverflow.identify.lastMouseDownEvent.clientX) < 3 && Math.abs(e.clientY - this.paramsContentOverflow.identify.lastMouseDownEvent.clientY) < 3) {
                    const parentRect = e.currentTarget.getBoundingClientRect();

                    this.paramsContentOverflow.identify.positionClick = {
                        x : (e.clientX - parentRect.left) / parentRect.width * 100,
                        y : (e.clientY - parentRect.top) / parentRect.height * 100,
                        idFile : this.medias[this.slideIndexCarousel].id
                    }
                }

        
                if (!this.modes.length && !e.target.classList.contains("VueCarousel-dot-button")) {
                    this.toggleMusic()
                }
                
            },

            resetClick() {
                this.paramsContentOverflow.identify.positionClick = undefined
            },

            slideChangeCarousel(index) {
                this.showTagPersonIndentifed = true
                this.slideIndexCarousel = index
            },
            closeContentOverflow() {
                EventBus.$emit('postCreatorRemoveMode', 'all')
                this.resetClick()
            },

            getClassForFloatingTag(x,y) {
                let tab = []
                if (y > 80) tab.push('bottom');
                else if (y < 20) tab.push('top');
                if (x > 80) tab.push('right');
                else if (x < 20) tab.push('left');
                return tab.join('-')
            },

            carouselPageChange(slideIndex) {
                
            },

            carouselTransitionStart() {
                console.log("carouselTransitionStart")
            },

            carouselTransitionEnd() {
                console.log("carouselTransitionEnd")
            },

            openInstagramPage(page) {
                const url = `https://www.instagram.com/${page.name}/`;
                window.open(url, '_blank');
            },

            toggleMusic() {
                if (!this.$refs['music-audio']) {
                    this.mutedSound = !this.mutedSound;
                } else {
                    this.$refs['music-audio'].setMute((isMuted) => {
                        this.mutedSound = !isMuted;
                        return !isMuted;
                    })
                }
                
            },

            nextIndexCarousel() {
                this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
            },
            prevIndexCarousel() {
                this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());

            }

        },

        computed: {
            formatDatePost: function(){
                if(this.datePost == false) return '';
                let dateNow = new Date()
                let dateFuture = new Date(this.datePost)

                const addHours = (dateString) => (`${dateString} à ${dateFuture.getHours()}h${dateFuture.getMinutes().toString().padStart(2, '0')}`)
        
                if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                    if (Math.abs(Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24))) < 7) {
                        if (dateFuture.getDay() === dateNow.getDay()) return addHours("Aujourd'hui")
                        if (dateFuture.getDay() === dateNow.getDay()+1) return addHours("Demain")
                        if (dateFuture.getDay() === dateNow.getDay()-1) return addHours("Hier")
                        return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' }));
                    }
                
                    if(dateFuture.getMonth() === dateNow.getMonth()) return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric'}));

                    return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'numeric' }));
                }
                return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' }));
            },

            textTranslateMentionAndHastag() {
                //return this.text
                let mentionCount = 0;
                return this.text.substring(0,2200).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        if (mentionCount < 20 && mention.mention && mention.mention.instagram) {
                            mentionCount++
                            return `<span class="mention">@${mention.mention.instagram.id || mention.mention.instagram.name}</span>`
                        }else{
                            return mention.textDefault
                        }
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            commentsTranslateMentionAndHastag() {
                //return this.text

                let mentionCount = 0;
                return this.comments.map(comment => (
                    comment.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        if (mentionCount < 20 && mention.mention && mention.mention.instagram) {
                            mentionCount++
                            return `<span class="mention">@${mention.mention.instagram.id || mention.mention.instagram.name}</span>`
                        }else{
                            return mention.textDefault;
                        }
                    }
                    return match;
                }).replace(/\n/g, '<br>')));
              
            },

            personsIdentifiedSlideCarousel() {
                if (!this.medias || !this.medias[this.slideIndexCarousel]) return []
                return this.personsIdentified.filter(person => 
                    this.medias[this.slideIndexCarousel].id == person.idFile || 
                    (this.slideIndexCarousel == 0 && !this.medias.some(media => media.id == person.idFile))
                );
            },
                       
            productSlideCarousel() {
                if (!this.medias || !this.medias[this.slideIndexCarousel]) return []
                return this.products.filter(product => 
                    this.medias[this.slideIndexCarousel].id == product.idFile || 
                    (this.slideIndexCarousel == 0 && !this.medias.some(media => media.id == product.idFile))
                ); 
            },

            ratioCalculated() {
                const media = this.medias[0];
                
                if (this.ratio == 'auto') {
                    if (!media) return '1:1';
                    if (media.info.aspectRatio > 1.91) return '1.91:1'; //limiter la resolution à 1.91
                    if (media.info.aspectRatio < 0.75) return '3:4';
                    
                    return `${media.info.width}:${media.info.height}`
                }
                
                return this.ratio
            },
           

        },
        watch: {
            modes: {
                deep: true,
                immediate: true,
                handler(newValue, oldValue) {
                    let audio = this.$refs['music-audio'];
                    if (audio) {
                        if (newValue.includes('addMusicMode')) {
                            audio.mute()
                        }else if (!this.mutedSound) {
                            audio.unmute()
                        }
                    }
                  
                },
            },
        }
        
    }
</script>
